import { Option } from '@joor/design-system'

export enum FieldIds {
  AddressOption = 'addressOption',
  CompanyName = 'companyName',
  RecipientName = 'recipientName',
  Address1 = 'address1',
  Address2 = 'address2',
  City = 'city',
  Country = 'country',
  BillingCode = 'billingCode',
  TaxNumber = 'order-review__order-review-addresses__tax-number',
  Territory = 'territory',
  PostalCode = 'postalCode',
  Phone = 'phone',
  PaymentMethod = 'paymentMethod',
}

export type BillingAddressFormValues = {
  [FieldIds.AddressOption]: Option | null
  [FieldIds.CompanyName]: string
  [FieldIds.RecipientName]: string
  [FieldIds.Address1]: string
  [FieldIds.Address2]: string
  [FieldIds.City]: string
  [FieldIds.Territory]: string
  [FieldIds.Country]: Option | null
  [FieldIds.TaxNumber]: string
  [FieldIds.PostalCode]: string
  [FieldIds.BillingCode]: string
  [FieldIds.Phone]: string
  [FieldIds.PaymentMethod]?: Option | null
}

export const EMPTY_FORM_STATE: BillingAddressFormValues = {
  [FieldIds.AddressOption]: null,
  [FieldIds.CompanyName]: '',
  [FieldIds.RecipientName]: '',
  [FieldIds.Address1]: '',
  [FieldIds.Address2]: '',
  [FieldIds.City]: '',
  [FieldIds.Territory]: '',
  [FieldIds.Country]: null,
  [FieldIds.TaxNumber]: '',
  [FieldIds.PostalCode]: '',
  [FieldIds.BillingCode]: '',
  [FieldIds.Phone]: '',
  [FieldIds.PaymentMethod]: null,
}
